import { MuiComponent } from "./type";

export const MuiBreadcrumbs: MuiComponent<"MuiBreadcrumbs"> = {
  styleOverrides: {
    root: {
      fontSize: '14px',
    },
  },
};